/* Dawn cart shared state */
(function () {
  'use strict';

  if (window.DDCartState) return;

  var state = {
    initialized: false,
    drawerOpen: false,
    qualifies: null,
    thresholdMet: false,
    evaluated: false,
    busy: false,
    pendingClaim: false,
    declined: false,
    hasColorRingInCart: false,
    lockedGiftImage: '',
  };

  window.DDCartState = {
    get: function () {
      return state;
    },
    patch: function (next) {
      Object.assign(state, next || {});
      return state;
    },
    reset: function () {
      state.initialized = false;
      state.drawerOpen = false;
      state.qualifies = null;
      state.thresholdMet = false;
      state.evaluated = false;
      state.busy = false;
      state.pendingClaim = false;
      state.declined = false;
      state.hasColorRingInCart = false;
      state.lockedGiftImage = '';
      return state;
    },
  };
})();
